import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NCashDataUtil } from '../../../../utils/finzy-flex/nCash-data.util';
import { AttributeCode, AttributeValue, InvestmentPreference, nCashDates, nCashFrequencies, UserAttribute } from '../../../../model/finzy-flex/user-attribute.model';

@Component({
  selector: 'app-custom-n-cash-attribute',
  templateUrl: './custom-n-cash-attribute.component.html',
  styleUrls: ['./custom-n-cash-attribute.component.scss']
})
export class CustomNCashAttributeComponent implements OnInit {
  private nCashDataUtil: NCashDataUtil;
  public frequencies = nCashFrequencies;
  public dates = nCashDates;
  public currentFrequency: number | AttributeValue;
  public currentDate: number | AttributeValue;
  public value = 100;
  public excessAmountAllocatedError = false;
  public maxNCashAmount: number = 0;

  @Input()
  userAttributes: InvestmentPreference[];

  @Input()
  userAttributesForm: FormGroup;

  @Input()
  customNCashAmount: number = 0;

  @Input()
  havePreferencesChanged: any;

  @Input()
  previousUserAttribute: UserAttribute;

  @Output()
  changeValue: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  userAttributesSwiftForm: FormGroup

  @Input()
  isSwiftEnabled: boolean

  @Input()
  backupSwiftAttribute: InvestmentPreference[] = []

  constructor(nCashDataUtil: NCashDataUtil) {
    this.nCashDataUtil = nCashDataUtil;
  }

  ngOnInit(): void {
    this.currentFrequency = this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_FREQUENCY).attributeValue;
    this.currentDate = this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_DATE_OF_MONTH).attributeValue;
    this.value = (this.customNCashAmount > 100) ? this.customNCashAmount : 100;
    this.onAttributeChange();
  }

  public async onFrequencyChange() {
    this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_FREQUENCY).attributeValue = this.currentFrequency;
    await this.onAttributeChange();
    this.changeCustomAmount();
    this.changeValue.emit(this.havePreferencesChanged());
  }

  public onDateChange() {
    this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_DATE_OF_MONTH).attributeValue = this.currentDate;
    this.changeValue.emit(this.havePreferencesChanged());
  }

  public changeCustomAmount() {
    const userAttribute = this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_AMOUNT);
    if (userAttribute) {
      userAttribute.attributeValue = this.value;
    } else {
      const investmentPreference: InvestmentPreference = {
        "attributeCode": AttributeCode.NCASH_WD_AMOUNT,
        "attributeValue": this.value
      }
      this.userAttributes.push(investmentPreference);
    }
    if ((this.value > this.maxNCashAmount) || (this.value < 100)) {
      this.excessAmountAllocatedError = true;
      this.userAttributesForm.controls.nCash.setErrors({ 'excessError': true });
    } else {
      this.excessAmountAllocatedError = false;
      this.userAttributesForm.controls.nCash.setErrors({ 'excessError': null });
      this.userAttributesForm.controls.nCash.updateValueAndValidity();
      this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_FREQUENCY).attributeValue = this.currentFrequency;
      this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_DATE_OF_MONTH).attributeValue = this.currentDate;
      this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_AMOUNT).attributeValue = this.value;
    }
    this.changeValue.emit(this.havePreferencesChanged());
  }

  private async onAttributeChange() {
    if (this.currentFrequency) {
      await this.nCashDataUtil.getNCashDetailsByLenderId(AttributeValue.MAX_LIMIT, this.currentFrequency.toString(), Number(this.currentDate) || 10)
        .then(nCashData => this.maxNCashAmount = nCashData.status === 0 ? nCashData.data[0].ncashAmount : 0)
        .catch(() => this.maxNCashAmount = 0);
    } else {
      this.maxNCashAmount = 0;
    }
  }
}
